import { createFileRoute } from '@tanstack/react-router'

// Critical (non-lazy) part of the route: only what the router needs to match the
// URL. The page component lives in `route.lazy.tsx` so it loads as a separate
// chunk from the booking flow.
export const Route = createFileRoute('/cancel/$token')({
	head: () => ({
		meta: [{ title: 'Cancel your interview · Jobilla' }],
	}),
})
